import { IInterval } from "../../../../Context/Interval";
import { ISystemContext } from "../../../../Context/SystemContext";
import { PixiSpriteResource } from "../../../../ResourceManager/PixiSpriteResource";
import { ResourceIdentifier } from "../../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../../ResourceManager/ResourceManager";
import { CanvasSprite } from "../../../../slot/Sprite/CanvasSprite";
import { SlotGameInitData } from "../../../../SlotGameInitData";
import { Translator } from "../../../../Translator";
import { LogGroup, Scale, CreateElement, Size } from "../../../.././MyHelpers";
import { Slide, SlideFactory2Params } from "./Slide";

export class FreeGamePlusOneSlideDoubleSlide extends Slide {
	
	protected logGroup: LogGroup;
	protected resid: ResourceIdentifier;

    protected bonusInstruction: HTMLElement = null;
    protected bonusTitle: HTMLElement = null;
    protected bonusTrigger: HTMLElement = null;
    protected bonusTrigger2: HTMLElement = null;
    protected bonusInstruction2: HTMLElement = null;

    protected bonusDescription: HTMLElement = null;
    public override translator: Translator;

    //protected maxFreeGames: number = 0;
    protected SpriteFreegame: CanvasSprite = null;

    protected container: HTMLElement = null;

    protected FGElement: CanvasSprite[] = [];
    protected WInElement: HTMLElement[] = [];

    //CREATE A CANVAS FOR WINCOUNT
    public winCountcanvas: HTMLCanvasElement[] = [];
    protected ctx: CanvasRenderingContext2D[] = [];
    protected fontHeight: number =  Scale.fh(80);
    protected fontHeight2: number = Scale.fh(70);
    protected fontHeight3: number = Scale.fh(60);

    protected SripiteTimerLeft: IInterval;

    protected plusone: CanvasSprite = null;

    protected SripiteTimer: IInterval;
    protected TitleSripiteTimer: IInterval;

    protected systemContext: ISystemContext;


    constructor(initData: SlotGameInitData, p: SlideFactory2Params , viewSize : Size) {
        super(initData, p , viewSize);

        
		this.logGroup = 	 this.p.logGroup.Add("FreeGamePlusOneSlideDoubleSlide");
		this.resid = 		 this.p.resid.Add("FreeGamePlusOneSlideDoubleSlide");
        this.viewSize = viewSize;

        this.view = CreateElement("div", {
            classes: ["FreeGameBonusPlusOne", this.resid.Scope()],
            style: {
                position: "absolute",
                height: this.viewSize.Height + "px",
                width: this.viewSize.Width + "px",
            }
        });

        this.systemContext = this.p.systemContext.CreateSubContext("FreeGameBonusPlusOne");
    }


    public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        resourceManager.Add(new PixiSpriteResource(this.path + "Slider2/FGRight", ResourceIdentifier.Global.Add(this.initData.GameName + "FGRight").Add("FreeGameBonusPlusOne"), true, this.logGroup.Add("FreeGameBonusPlusOne"), true));

    }

    public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

        this.SpriteFreegame = new CanvasSprite({sprite: resourceManager.Get<PixiSpriteResource>(ResourceIdentifier.Global.Add(this.initData.Name + "FGRight").Add("FreeGameBonusPlusOne")).sprite, canvasSize: new Size( this.viewSize.Width,  this.viewSize.Height)});
        this.SpriteFreegame.View().style.position = "relative";
        this.view.appendChild(this.SpriteFreegame.View());
        this.TitleSripiteTimer = this.systemContext.TimingContext().CreateInterval("FreeGameBonusPlusOne", this.nextAnimInterval, () => this.SpriteFreegame.Start(false));
	}


	public override View(): HTMLElement
	{
		return this.view;
	}
	
	public override Update()
	{
		this.SpriteFreegame.Update();
	}
	
	public override Start() 
	{
		this.TitleSripiteTimer.Start();
	}

	public override Stop() 
	{
		this.TitleSripiteTimer.Start();
		this.SpriteFreegame.StopAndReset();
	}
}
